import { useScrolled } from "../../hooks/useScrolled";
import { NAV_LINKS } from "../../constants/navLinks";
import Brand from "./Brand";
import ThemeToggle from "./ThemeToggle";
import "./Header.css";

const Header = ({ activeId, theme, onToggleTheme }) => {
  const scrolled = useScrolled(16);

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="nav__inner container">
        <Brand />

        <nav className="nav__menu" aria-label="Primary">
          <ul>
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className={activeId === l.href.slice(1) ? "is-active" : ""}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <ThemeToggle theme={theme} onToggle={onToggleTheme} />
          <a href="#contact" className="btn btn-primary nav__cta">
            Let's Talk <i className="fa-solid fa-arrow-right" />
          </a>
        </nav>

        <ThemeToggle theme={theme} onToggle={onToggleTheme} className="nav__theme--mobile" />
      </div>
    </header>
  );
};

export default Header;
